import { createRoot } from 'react-dom/client'
import { ClerkProvider } from '@clerk/clerk-react'
import { ErrorBoundary } from './components/ErrorBoundary'
import { AuthBypassProvider, isAuthBypassEnabled, BypassIndicator } from './providers/AuthBypass'
import App from './App.tsx'
import './index.css'

const clerkPubKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;
const convexUrl = import.meta.env.VITE_CONVEX_URL;
const authBypass = isAuthBypassEnabled();

// DEBUG: Log environment for mobile debugging
console.log('🔍 ENV DEBUG:', {
  clerkKey: clerkPubKey ? `${clerkPubKey.substring(0, 20)}...` : '❌ MISSING',
  convexUrl: convexUrl ? `${convexUrl.substring(0, 30)}...` : '❌ MISSING',
  authBypass: authBypass ? '🔓 ENABLED' : 'disabled',
  mode: import.meta.env.MODE,
  prod: import.meta.env.PROD,
  base: import.meta.env.BASE_URL,
  allEnvKeys: Object.keys(import.meta.env).filter(k => k.startsWith('VITE_'))
});

// Auth Bypass Mode - for development/testing without Clerk
if (authBypass) {
  console.log('🔓 AUTH BYPASS MODE ACTIVE - Clerk authentication disabled');
  createRoot(document.getElementById("root")!).render(
    <ErrorBoundary>
      <AuthBypassProvider>
        <BypassIndicator />
        <App />
      </AuthBypassProvider>
    </ErrorBoundary>
  );
} else {
  // Normal mode - require Clerk
  if (!clerkPubKey) {
    console.error('❌ Missing VITE_CLERK_PUBLISHABLE_KEY');
  }

  if (!convexUrl) {
    console.warn('⚠️ Missing VITE_CONVEX_URL');
  }

  // Error fallback for missing Clerk key
  if (!clerkPubKey) {
    createRoot(document.getElementById("root")!).render(
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        padding: '1rem',
        fontFamily: 'system-ui, -apple-system, sans-serif'
      }}>
        <div style={{
          maxWidth: '28rem',
          textAlign: 'center',
          background: 'white',
          padding: '2rem',
          borderRadius: '0.5rem',
          boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
        }}>
          <h1 style={{ fontSize: '1.5rem', fontWeight: 'bold', marginBottom: '1rem' }}>
            Configuration Error
          </h1>
          <p style={{ color: '#666', marginBottom: '1rem' }}>
            The application is not properly configured. Please contact support.
          </p>
          <p style={{ fontSize: '0.875rem', color: '#999' }}>
            Error: Missing authentication configuration
          </p>
        </div>
      </div>
    );
  } else {
    createRoot(document.getElementById("root")!).render(
      <ErrorBoundary>
        <ClerkProvider publishableKey={clerkPubKey}>
          <App />
        </ClerkProvider>
      </ErrorBoundary>
    );
  }
}
